import {
  MaturityRangeValues,
  MATURITY_RANGE_VALUES,
} from "@/search/Langston/SearchPage/SearchPage.constants";

export const sliderMarks = MATURITY_RANGE_VALUES.map((group, index) => ({
  value: index,
  abbreviation: group.abbreviation,
})).map(({ value, abbreviation }) => {
  return { value, label: abbreviation };
});

export const getMaturityRangeFromRange = (maturityRange: number[]) => {
  const minRange = maturityRange[0] as number;
  const maxRange = maturityRange[1] as number;

  if (maturityRange.length !== 2) return {};

  // get the minumum and maxiumum possible grade from grade range array
  const min = MATURITY_RANGE_VALUES[minRange]?.value[0];
  const max =
    MATURITY_RANGE_VALUES[maxRange]?.value[
      (MATURITY_RANGE_VALUES[maxRange] as MaturityRangeValues)?.value.length - 1
    ];

  return { min, max };
};

export const getRangeFromParams = (min: number, max: number) => {
  const minRangeValue = MATURITY_RANGE_VALUES.find((rangeObj) =>
    rangeObj.value.includes(min),
  );
  const maxRangeValue = MATURITY_RANGE_VALUES.find((rangeObj) =>
    rangeObj.value.includes(max),
  );

  const lowerRangeIndex = MATURITY_RANGE_VALUES.indexOf(
    minRangeValue as MaturityRangeValues,
  );
  const higherRangeIndex = MATURITY_RANGE_VALUES.indexOf(
    maxRangeValue as MaturityRangeValues,
  );

  return [lowerRangeIndex, higherRangeIndex];
};

export const getAriaLabel = (index: number) => {
  if (index === 0) return "Minimum Grade Range Thumb Slider";
  return "Maximum Grade Range Thumb Slider";
};
